// CustomSelect.js
import React, {FC, useEffect, useState} from 'react'
import {useQuery} from 'react-query'
import Select from 'react-select'
import clsx from 'clsx'
import {getStatusSelect} from '../core/_request'

interface Props {
  value?: number
  onChange: (value: any) => void
  className?: string
  defaultOption?: any
  initialOptions?: any[]
  disabled?: boolean
  isClearable?: boolean
  placeholder?: string
}

const ReportStatusSelect: FC<Props> = ({
  value,
  onChange,
  className = '',
  placeholder = 'Status',
  disabled = false,
  isClearable = false,
  ...rest
}) => {
  const [options, setOptions] = useState<any[]>([])

  const fetchData = async ({pageParam = 1}) => {
    try {
      const response = await getStatusSelect()

      return response.data
    } catch (ex) {
      console.log(ex)
      return undefined
    }
  }

  const {isLoading, data, refetch, isFetching} = useQuery('report-status-select', fetchData, {
    enabled: false,
    cacheTime: 0,
  })

  const formatLabel = (option: any) => {
    return (
      <article className='custom-option text-wrap' style={{lineHeight: 1.1}}>
        <div>
          {/* {option.degree} - {option.label} <small className='sub'>({option.code})</small> */}
          {option.label}
        </div>
      </article>
    )
  }

  const handleChange = (selectedOption) => {
    console.log(selectedOption)
    onChange(selectedOption)
  }

  useEffect(() => {
    if (data) {
      const result = data.map((q) => {
        return {
          value: q?.id,
          label: q?.name,
        }
      })
      setOptions(result)
    }
  }, [data])

  useEffect(() => {
    refetch()
  }, [])

  return (
    <Select
      {...rest}
      name='ReportStatusSelect'
      options={options}
      onChange={handleChange}
      value={options.find((option) => (value ? option.value === value : undefined))} // Set the initial selected value
      classNamePrefix='react-select'
      className={clsx('react-select', className)}
      placeholder={placeholder}
      styles={{
        menuPortal: (base) => ({...base, zIndex: 9999}),
        placeholder: (base) => ({...base, color: '#99A1B7'}),
      }}
      menuPortalTarget={document.body}
      menuShouldScrollIntoView={false}
      isDisabled={disabled}
      formatOptionLabel={(data) => formatLabel(data)}
      isClearable={isClearable}
    />
  )
}

export default ReportStatusSelect
